<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('targets')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('ASM')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('targets')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Targets -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('target')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="target" matSortDirection="asc" matSortDisableClear>

                        <!-- Target Column -->
                        <ng-container matColumnDef="target">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('target')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.name}}
                            </td>
                        </ng-container>

                        <!-- Description Column -->
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('description')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.description}}
                            </td>
                        </ng-container>

                        <!-- Added On Column -->
                        <ng-container matColumnDef="addedOn">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('added-on')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <span class="badge text-soft-primary">{{row.insert_date}},
                                    {{row.insert_date_humanized}}</span>
                            </td>
                        </ng-container>

                        <!-- Last Scanned Column -->
                        <ng-container matColumnDef="lastScanned">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('last-scanned')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.start_scan_date_humanized) {
                                <span class="badge text-soft-primary">{{row.start_scan_date_humanized}}</span>
                                }
                                @else{
                                <span class="badge text-soft-warning">{{t('never-scanned-before')}}</span>
                                }
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">

                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
